const paymentTypes = [
	{
		value: "1",
		label: "Bonus",
	},
	{
		value: "2",
		label: "World",
	},
	{
		value: "3",
		label: "Maximum Card",
	},
	{
		value: "4",
		label: "Axess",
	},
	{
		value: "5",
		label: "CardFinans",
	},
	{
		value: "6",
		label: "Ziraat Bankası",
	},
	{
		value: "7",
		label: "Paraf",
	},
	{
		value: "14",
		label: "TEB",
	},
	{
		value: "8",
		label: "Odedim.com",
	},
	{
		value: "9",
		label: "Iyzico",
	},
	{
		value: "12",
		label: "IPara",
	},
	{
		value: "13",
		label: "Moka",
	},
	{
		value: "15",
		label: "PayTR",
	},
]
export default paymentTypes;